export default __webpack_public_path__ + "static/media/dixneuf.93743e1b.png";